<template>
  <div class="md-layout">
    <div
      class="md-layout md-layout-item black-border md-size-70 md-medium-size-100"
    >
      <div class="md-layout-item md-size-100">
        <md-card
          id="job-container"
          class="md-layout md-layout-item md-size-100 md-medium-size-100 job-container"
        >
          <md-icon v-if="working" class="text-info status-icon working"
            >cached</md-icon
          >
          <md-icon v-else class="text-success status-icon done">done</md-icon>
          <router-link :to="previousLink()">
            <md-button class="md-just-icon md-simple md-round back-button">
              <md-icon>arrow_back</md-icon>
            </md-button>
          </router-link>

          <md-card-content>
            <ValidationObserver v-slot="{ invalid }">
              <div class="md-layout">
                <div class="md-layout-item md-size-95 mx-auto">
                  <h3>Posao</h3>
                </div>
                <div class="md-layout md-layout-item md-size-100">
                  <div
                    class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100"
                  >
                    <ValidationProviderExtended
                      name="Naziv posla"
                      rules="between:2,50"
                      className="md-warning"
                    >
                      <label>Naziv posla</label>
                      <md-input v-model="job.jobName" type="text"> </md-input>
                    </ValidationProviderExtended>

                    <div class="md-layout md-layout-item md-size-100">
                      <ValidationProviderExtended
                        name="Tip posla"
                        rules="required"
                        className="md-layout-item md-size-50"
                      >
                        <label>Tip posla</label>
                        <md-select v-model="job.jobType.id">
                          <md-option
                            v-for="(option, index) in jobTypes"
                            :key="index"
                            :value="option.id"
                            >{{ option.name }}</md-option
                          >
                        </md-select>
                      </ValidationProviderExtended>

                      <ValidationProviderExtended
                        name="Tiraž"
                        rules="required|positive"
                        className="md-layout-item md-size-50"
                      >
                        <label>Tiraž</label>
                        <md-input v-model="job.circulations" type="number">
                        </md-input>
                      </ValidationProviderExtended>
                    </div>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-medium-size-50 md-small-size-100"
                  >
                    <div class="md-layout-item md-size-100">
                      <drop-down direction="down" multiLevel>
                        <md-button
                          slot="title"
                          class="md-layout-item md-size-100 dropdown-toggle item-dropdown"
                          :class="[job.format ? 'md-primary' : 'md-inactive']"
                          data-toggle="dropdown"
                        >
                          <span id="format-dropdown">{{
                            'Format' +
                              (job.format.name ? ': ' + job.format.name : '')
                          }}</span>
                        </md-button>
                        <ul class="dropdown-menu">
                          <li
                            v-for="(format, index) in formats"
                            :key="index"
                            @click="toggleMultiLevel(index)"
                          >
                            <a
                              class="dropdown-toggle"
                              :class="{ open: multiLevel === index }"
                              >{{ format.group }}</a
                            >
                            <ul
                              class="dropdown-menu dropdown-menu-right md-layout"
                            >
                              <li
                                v-for="(option, index) in format.list"
                                :key="index"
                              >
                                <div
                                  class="md-layout"
                                  v-if="Array.isArray(option)"
                                >
                                  <md-field
                                    v-for="(item, index) in option[0]"
                                    :key="index"
                                    class="md-layout-item md-size-45 mx-auto no-increment"
                                  >
                                    <label>
                                      {{ item.label }}
                                    </label>
                                    <md-input
                                      v-model="job.format[item.name]"
                                      type="number"
                                      :min="item.min"
                                      :step="item.step"
                                      @blur="setCustomFormat"
                                    >
                                    </md-input>
                                  </md-field>
                                </div>

                                <a
                                  v-else
                                  @click="selectOption(option.id, option.label)"
                                  >{{ option.label }}</a
                                >
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </drop-down>
                    </div>

                    <div class="md-layout md-layout-item">
                      <ValidationProviderExtended
                        name="Broj stranica"
                        rules="required|positive"
                        className="md-layout-item md-size-50"
                      >
                        <label>Broj stranica</label>
                        <md-input
                          v-model="job.numOfPages"
                          @focus="focus = 'pages'"
                          type="number"
                        >
                        </md-input>
                      </ValidationProviderExtended>
                      <ValidationProviderExtended
                        name="Broj stranica"
                        rules="required|positive"
                        className="md-layout-item md-size-50"
                      >
                        <label>Listova</label>
                        <md-input
                          v-model="numOfPapers"
                          @focus="focus = 'papers'"
                          type="number"
                        >
                        </md-input>
                      </ValidationProviderExtended>
                    </div>
                  </div>

                  <div
                    class="md-layout-item md-size-20 md-medium-size-50 md-small-size-100"
                  >
                    <div class="md-layout-item md-size-100">
                      <md-radio v-model="job.orientation" value="vertical">
                        Portret
                      </md-radio>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-radio v-model="job.orientation" value="horizontal">
                        Landscape
                      </md-radio>
                    </div>
                  </div>
                  <div
                    class="md-layout-item md-size-10 md-medium-size-50 md-small-size-100"
                  >
                    <md-button
                      class="md-info md-layout-item md-size-100"
                      @click="submitJob"
                      :disabled="invalid"
                    >
                      <md-icon> change_circle </md-icon>
                      Preračunaj
                    </md-button>
                    <md-button
                      v-if="job.jobItems.length"
                      class="md-success md-layout-item md-size-100"
                      @click="saveJob"
                      :disabled="invalid"
                    >
                      <md-icon> save </md-icon>
                      Sačuvaj
                    </md-button>
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout">
        <JobItem
          v-if="mode === 'item'"
          :index="itemIndex"
          ref="jobItemWindow"
          @new-calculation="updateTable"
          @ready-to-save="allowSave"
        />
        <Binding
          v-else-if="mode === 'binding'"
          @new-calculation="
            updateTable();
            setWorking();
          "
        />
      </div>
    </div>
    <div
      class="md-layout md-layout-item md-size-30 md-medium-size-100 items-and-binding"
    >
      <div class="md-layout-item md-size-100">
        <tabs
          id="item-tabs"
          :tab-name="[
            'Stavka +',
            ...job.jobItems.map(item => item.name),
            'Povezivanje',
          ]"
          color-button="primary"
        >
          <div slot="header-title">
            <h3 class="title">Stavke</h3>
            <span>
              <drop-down direction="down" multiLevel class="floating-note">
                <md-button
                  slot="title"
                  data-toggle="dropdown"
                  class="md-just-icon"
                  :class="job.comment ? 'md-info' : ''"
                >
                  <md-icon> assignment </md-icon>
                </md-button>
                <ul class="dropdown-menu dropdown-menu-right note-container">
                  <md-field>
                    <label> Napomena </label>
                    <md-textarea class="note-textarea" v-model="job.comment">
                    </md-textarea>
                  </md-field>
                </ul>
              </drop-down>
            </span>
          </div>

          <!-- here you can add your content for tab-content -->
          <template
            v-for="(item, index) in [
              { function: 'newItem' },
              ...job.jobItems,
              bindingTabInfo,
            ]"
            :slot="'tab-pane-' + (index + 1)"
          >
            <div :key="index" class="item-description">
              <md-button
                v-if="
                  (item &&
                    itemIndex === index - 1 &&
                    mode === 'item' &&
                    canSave) ||
                    (item.function &&
                      item.function === 'binding' &&
                      mode === 'binding')
                "
                class="md-success md-round md-just-icon"
                @click="saveItem"
              >
                <md-icon> save </md-icon>
              </md-button>
              <md-button
                v-if="
                  !(
                    item.function &&
                    item.function === 'binding' &&
                    (!job.jobItems.length || mode === 'binding')
                  ) && !(mode === 'item' && itemIndex === index - 1)
                "
                class="md-round md-just-icon"
                @click="itemTabs(item, index - 1)"
              >
                <md-icon>create</md-icon>
              </md-button>
              <md-button
                v-if="
                  (mode === null && item.discountedPrice) ||
                    (item.function === 'newItem' && mode === 'item')
                "
                class="md-round md-just-icon md-danger"
                @click="removeItem(index - 1)"
              >
                <md-icon>delete</md-icon>
              </md-button>

              <h4 v-if="item && item.discountedPrice">
                {{ 'Cijena ' + priceDisplay(item.discountedPrice) }}
              </h4>
              <h4
                v-else-if="item && item.function && item.function === 'binding'"
              >
                {{ 'Cijena ' + priceDisplay(job.bindingPrice) }}
              </h4>
            </div>
          </template>
        </tabs>
      </div>
      <div class="md-layout-item md-size-100 item-table">
        <md-card id="item-table">
          <md-card-content>
            <md-table class="scroll-table table-striped">
              <md-table-row
                v-for="(row, index) in itemTable"
                :key="index"
                :id="row.id"
              >
                <md-table-cell>
                  <b> {{ fillTableRow(row, 'label') }}</b>
                </md-table-cell>
                <md-table-cell class="text-success">
                  <span
                    v-if="priceEditIndex !== index"
                    @click="startDiscount(index)"
                  >
                    {{ fillTableRow(row, 'price') }}
                  </span>
                  <md-field v-else>
                    <md-input
                      type="number"
                      min="0"
                      step="0.01"
                      @blur="setDiscount"
                    >
                    </md-input>
                  </md-field>
                </md-table-cell>
                <md-table-cell class="text-danger">
                  {{ fillTableRow(row, 'expense') }}
                </md-table-cell>
                <md-table-cell class="text-warning">
                  {{ fillTableRow(row, 'profit') }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
        <md-card v-if="job.totalPrice">
          <md-card-content class="md-layout add-padding">
            <h3 class="ml-auto">
              {{ 'Cijena posla ' + priceDisplay(job.totalPrice) }}
            </h3>
            <h3 class="ml-auto">
              {{
                'Jedinična cijena ' +
                  priceDisplay(job.totalPrice / job.circulations)
              }}
            </h3>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
import { extend } from 'vee-validate';
import api from '../api/api.js';
import services from '@/api/services';
import JobItem from '@/pages/JobItem.vue';
import Binding from '@/components/Binding.vue';
import { Tabs } from '@/components';
import { min, numeric, required } from 'vee-validate/dist/rules';

extend('required', required);
extend('numeric', numeric);
extend('min', min);

export default {
  components: {
    JobItem,
    Tabs,
    Binding,
    ValidationProviderExtended,
  },
  data() {
    return {
      formats: null,
      multiLevel: null,
      itemTable: null,
      mode: null,
      jobTypes: [],
      working: false,
      ready: false,
      confirmed: false,
      job: {
        jobName: null,
        formatId: null,
        format: {
          name: null,
          height: null,
          width: null,
        },
        circulations: null,
        numOfPages: null,
        jobType: {
          id: null,
          name: null,
          hasPages: null,
        },
        orientation: 'vertical',
        jobItems: [],
        comment: '',
      },
      itemIndex: null,
      canSave: false,
      focus: null,
      priceEditIndex: null,
    };
  },
  computed: {
    numOfPapers: {
      get() {
        if (this.job.numOfPages !== null) {
          return Math.ceil(this.job.numOfPages / 2);
        } else {
          return null;
        }
      },
      set(value) {
        if (this.focus === 'papers') this.job.numOfPages = value * 2;
      },
    },
    bindingTabInfo() {
      if (this.job.binding && this.job.binding.prices) {
        return {
          discountedPrice: this.job.bindingPrice,
          function: 'binding',
        };
      } else {
        return {
          function: 'binding',
        };
      }
    },
  },
  methods: {
    toggleMultiLevel(index) {
      this.multiLevel = index;
    },
    selectOption(id, label) {
      this.job.formatId = id;
      this.job.format.name = label;
    },
    itemTabs(item, index) {
      this.canSave = false;

      (() => {
        if (
          this.itemIndex !== -1 &&
          this.itemIndex !== null &&
          this.mode === 'item'
        ) {
          return this.saveItem();
        } else if (this.itemIndex === -1 && this.mode === 'item') {
          return api
            .post(services.item.cancelItem, { cancelItem: true })
            .then(data => {
              this.mode = null;
              if (data.job) this.job = data.job;
              if (data.table) this.itemTable = data.table;
            });
        } else {
          return Promise.resolve();
        }
      })()
        .then(() => {
          if (item.function) {
            if (item.function === 'newItem') {
              this.mode = 'item';
              this.itemIndex = -1;
            } else if (item.function === 'binding') {
              api
                .post(services.job.bindingPrep, { bindingPrep: true })
                .then(() => {
                  this.mode = 'binding';
                  this.itemIndex = null;
                  this.working = true;
                })
                .catch(error => {
                  this.alertError(error);
                });
            }
          } else {
            this.itemIndex = index;
            this.mode = 'item';
          }
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    removeItem(index) {
      if (this.mode === null && index >= 0) {
        return api
          .post(services.item.removeItem, {
            removeItem: true,
            itemIndex: index,
          })
          .then(data => {
            if (data.job) this.job = data.job;
            if (data.table) this.itemTable = data.table;
            else this.itemTable = [];
          });
      } else if (index === -1 && this.mode === 'item') {
        return api
          .post(services.item.cancelItem, { cancelItem: true })
          .then(data => {
            this.mode = null;
            if (data.job) this.job = data.job;
            if (data.table) this.itemTable = data.table;
            else this.itemTable = [];
          });
      }
    },
    syncJobInfo() {
      this.working = true;
      return this.syncOfferInfo().then(data => {
        this.confirmed = !!data.offerInfo.confirmed;
        if (this.$route.query.offerId !== null && !data.job) {
          return api.post(services.job.editCachedJob, { editJob: true }).then(
            data => {
              if (data.job) this.job = data.job;
              if (data.table) this.itemTable = data.table;
              if (data.ready) this.ready = data.ready;
              this.working = false;
            },
            error => {
              this.alertError(error);
            },
          );
        } else if (this.$route.query.offerId && data.job) {
          if (data.job) this.job = data.job;
          if (data.globalTable) this.itemTable = data.globalTable;
          if (data.ready) this.ready = data.ready;
          this.working = false;
        } else if (this.$route.query.offerId === undefined) {
          if (data.job || data.globalTable)
            api.post(services.job.cancelJob, { cancelJob: true });
        }
      });
    },
    setWorking(value = true) {
      window.setTimeout(() => {
        this.working = value;
      }, 100);
    },
    setCustomFormat() {
      this.job.formatId = {
        height: parseInt(this.job.format.height),
        width: parseInt(this.job.format.width),
      };
      this.job.format.name = `C - ${this.job.format.height} X ${this.job.format.width}`;
    },
    updateTable() {
      api.get(services.item.getItemTable, { getItemTable: true }).then(data => {
        this.itemTable = data;
      });
    },
    submitJob() {
      this.working = true;

      const requestParams = {
        mainPriceCalc: true,
        type: this.job.jobType.id,
        jobName: this.job.jobName,
        orientation: this.job.orientation,
        circulations: this.job.circulations,
        comment: this.job.comment,
        pages: this.job.numOfPages,
        formatId: JSON.stringify(this.job.formatId),
      };

      return api
        .post(services.job.jobPriceCalculations, requestParams)
        .then(data => {
          if (data.job) this.job = data.job;
          if (data.table) this.itemTable = data.table;
          if (data.ready) this.ready = true;
          this.$emit('submited-job', true);
          this.setWorking(false);
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    setJobParam(param, value) {
      this.job[param] = value;
    },
    saveItem() {
      if (this.mode === 'item') {
        return api
          .post(services.item.finishItem, { finishItem: true })
          .then(data => {
            if (data.job) this.job = data.job;
            if (data.table) this.itemTable = data.table;
            this.itemIndex = null;
            this.mode = null;
            return data;
          })
          .catch(error => {
            this.alertError(error);
          });
      } else {
        this.itemIndex = null;
        this.mode = null;
      }
    },
    previousLink() {
      const query = { id: this.$route.query.offerId };
      if (this.confirmed) query.filter = 'confirmed';

      return {
        path: 'files',
        query,
      };
    },
    pushToOffers() {
      this.$router.push(this.previousLink());
    },
    saveJob() {
      this.submitJob().then(() => {
        api
          .post(services.job.finishJob, { finishJob: true })
          .then(() => {
            this.pushToOffers();
          })
          .catch(error => {
            this.alertError(error);
          });
      });
    },
    allowSave() {
      this.canSave = true;
    },
    fillTableRow(row, column) {
      let tempRow;
      if (typeof row === 'object') tempRow = Object.values(row);
      else if (Array.isArray(row)) tempRow = row;

      if (column === 'label' && tempRow.length) {
        const label =
          tempRow[0].label + (tempRow.length > 1 ? `(${tempRow.length})` : '');
        return label;
      } else if (tempRow.length) {
        const rawNum =
          Math.round(
            tempRow.reduce((ac, el) => {
              if (column === 'price') return ac + el.price;
              else if (column === 'expense') return ac + el.expense;
              else if (column === 'profit') return ac + el.profit;
            }, 0) * 100,
          ) / 100;
        const num = this.priceDisplay(rawNum);

        return isNaN(rawNum) ? null : num;
      } else {
        return null;
      }
    },
    setDiscount() {
      this.priceEditIndex = null;
    },
    startDiscount(index) {
      this.priceEditIndex = index;
    },
  },
  mounted() {
    this.syncJobInfo().then(() => {
      api.get(services.getJobTypes, { loadJobTypes: true }).then(data => {
        this.jobTypes = data;
        api
          .get(services.getFormats, {
            loadFormats: true,
            itemOnly: true,
          })
          .then(data => {
            this.formats = data;
            this.job.format.height = this.formats[3].list[0][0][0].selected;
            this.job.format.width = this.formats[3].list[0][0][1].selected;
          })
          .catch(error => {
            this.alertError(error);
          });
      });
    });
  },
  watch: {
    $route() {
      this.syncJobInfo();
    },
    job: {
      handler(to, from) {
        if (from !== null) this.working = true;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';
.md-layout.md-layout-item.md-size-30.md-medium-size-100.items-and-binding {
  align-content: flex-start;
}
.md-content.md-table.scroll-table.table-striped.md-theme-default {
  max-height: 800px;
}
.status-icon {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1200;
}
.working {
  animation: rotate 1s linear infinite;
}
.md-card-content {
  width: 100%;
}
.md-menu-content.md-select-menu {
  z-index: 1000;
  width: 100%;
}
.md-layout {
  align-content: flex-start;
}
.md-button {
  text-transform: none;
  font-size: 0.95em;
}
.md-card {
  margin: 0 0 15px 0 !important;
}
.md-button {
  text-transform: none;
  font-size: 1.1em;
  font-weight: 400;
}
.back-button {
  position: absolute !important;
  top: 0.2em;
  left: 0.5em;
  z-index: 1000;
}
.md-inactive.checkbox-button,
.md-inactive.checkbox-button i,
.md-inactive.item-dropdown,
.md-inactive.item-dropdown i {
  color: $brand-primary !important;
}
.md-layout-item {
  padding: 0px 5px !important;
}
.items-and-binding {
  justify-content: flex-start;
}
.item-dropdown {
  margin-top: -5px;
}
.item-description {
  display: block;
  text-align: right;
}
.scroll-table {
  overflow-y: auto;
  max-height: 70%;
}
.floating-note {
  position: absolute;
  right: 1em;
  top: 1em;
}
.note-textarea {
  min-width: 25em;
  padding: 1em;
}
.note-container {
  padding: 0.5em 1.5em;
}
.no-increment::-webkit-outer-spin-button,
.no-increment::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.add-padding {
  padding: 15px;
}
</style>
